module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/133-saudi-arabia-2234125ff64c6955c597233481a4ce68.svg";